import WaybillsTableColumnCalculationType from './index.vue'
export default WaybillsTableColumnCalculationType